var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button } from "semantic-ui-react";
var DeleteLineItemModal = /** @class */ (function (_super) {
    __extends(DeleteLineItemModal, _super);
    function DeleteLineItemModal(props) {
        var _this = _super.call(this, props) || this;
        _this.submit = function () {
            _this.props.deleteRequest("/admin/orders/id/" + encodeURIComponent(_this.props.orderId) + "/line-items/id/" + encodeURIComponent(_this.props.lineItemId.toString()));
        };
        return _this;
    }
    DeleteLineItemModal.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement("p", null, "Are you sure?"),
            React.createElement(Button, { disabled: this.props.state.loading || this.props.state.success, icon: 'plus', label: 'Delete line item', labelPosition: 'left', onClick: this.submit, negative: true }));
    };
    return DeleteLineItemModal;
}(React.PureComponent));
export default DeleteLineItemModal;
;
//# sourceMappingURL=DeleteLineItemModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/DeleteLineItemModal.js
// module id = 1256
// module chunks = 0